









import LoaderPickup from "./LoaderPickup.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
	components: {
		LoaderPickup
	}
})
export default class Observer extends Vue {
	observer: any;
	loading: boolean = false;
	@Prop({}) readonly options;

	mounted() {
		const options = this.options || {};
		this.observer = new IntersectionObserver(([entry]) => {
			if (entry && entry.isIntersecting) {
				this.$emit("intersect");
				this.loading = true;
			} else {
				this.loading = false;
			}
		}, options);

		this.observer.observe(this.$el);
	}
	destroyed() {
		this.observer.disconnect();
	}
}
